import React, { useState } from "react";

function ForeclosureCleanoutFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "Do I need to do the cleanup myself?",
      content: `
No! We handle everything, from removing unwanted items to cleaning up the property.
      `,
    },
    {
      title: "What’s the best way to handle a foreclosure cleanout?",
      content: `
      Hiring a professional junk removal company like Junk Droid is the most efficient and stress-free way to handle it.
      `,
    },
    {
      title: "How much does a foreclosure cleanout cost?",
      content: `
       The cost depends on factors such as the size of the property and the amount of junk to be removed. Contact us for a free estimate!
      `,
    },
    {
      title: "Can you remove large furniture and appliances?",
      content: `
         Yes, we specialize in removing all types of large items, including furniture and appliances.
        `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default ForeclosureCleanoutFAQs;
